import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";

import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";
import { CustomToastContent } from "../../../../examples/CustomToastContent/index";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component
import Select from "react-select";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";

import CreateTestRecordModal from "../CreateTestRecordModal/index";

import {
  getTensileTest,
  createTensileTest,
  editTensileTest,
  deleteTensileTest,
  getProductsListForDpp,
  getSubModulesByRoleId,
  uploadCsvForTensileTest,
} from "../../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "auto",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const TensileTest = ({
  getTensileTestReducer,
  getTensileTest,
  createTensileTest,
  editTensileTest,
  deleteTensileTest,
  dppIdSelectedForGlobalFilter,
  dropdownUI,
  getProductsListForDpp,
  getProductsListForDppReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForTensileTest,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a5fde116-00b7-4ce0-939b-2482c5d161e1",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "896c7b19-7fe5-4306-9f06-2735e57a7b84",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "9acd851e-2dc1-4bd1-a480-e7621d85ace8",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "483ae968-cc38-4d30-ba63-887e9d32ba71",
    )
    : null;

  const [loading, setLoading] = useState(true);

  const [dppOptions, setDPPOptions] = useState([]);
  const [dppIdSelected, setdppIdSelected] = useState("");
  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const [openCreateModal, setOpenCreateModal] = useState(false);

  // Fetch Initial Data
  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      getTensileTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      getTensileTest(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  useEffect(() => {
    getProductsListForDpp(jwtToken);
  }, [jwtToken]);
  useEffect(() => {
    let tempDppOptions = [];
    let dataList = getProductsListForDppReducer?.productsListForDpp?.data
      ? getProductsListForDppReducer.productsListForDpp.data
      : [];

    dataList.forEach((item) => {
      tempDppOptions.push({
        label: item.dppCode,
        value: item.dppId,
      });
    });

    setDPPOptions(tempDppOptions);
  }, [getProductsListForDppReducer]);

  // DataTable State
  const [state, setState] = useState({
    columns: [
      { Header: "Test ID", accessor: "tensileTestId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Notch Impact Strength (Mean)(kJ/m²) ", accessor: "notchimpactStrengthMean" },
      { Header: "Yield Proof Strength (Mean)(N/mm²)", accessor: "yeildProofStrengthMean" },
      { Header: "Tensile Strength (Mean)(MPa)", accessor: "tensileStrengthMean" },
      { Header: "Temperature (°C)", accessor: "testTemperature" },
      { Header: "Location of Sample", accessor: "sampleShapeLocationOfSample" },
      { Header: "Direction of Sample", accessor: "directionOfSample" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;


  const headers = [
    // { label: "Test ID", key: "tensileTestId" },  
    { label: "DPP Code", key: "dppCode" },
    { label: "Notch Impact Strength (Mean) (kJ/m²)", key: "notchImpactStrengthMean" },
    { label: "Yield Proof Strength (Mean) (N/mm²)", key: "yieldProofStrengthMean" },
    { label: "Tensile Strength (Mean) (MPa)", key: "tensileStrengthMean" },
    { label: "Test Temperature (°C)", key: "testTemperature" },
    { label: "Sample Location", key: "sampleShapeLocationOfSample" },
    { label: "Direction of Sample", key: "directionOfSample" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "notchImpactStrengthMean", key: "notchImpactStrengthMean" },
    { label: "yieldProofStrengthMean", key: "yieldProofStrengthMean" },
    { label: "tensileStrengthMean", key: "tensileStrengthMean" },
    { label: "testTemperature", key: "testTemperature" },
    { label: "sampleShapeLocationOfSample", key: "sampleShapeLocationOfSample" },
    { label: "directionOfSample", key: "directionOfSample" }
  ];

  const csvLink = {
    filename: "Tensile Test List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Tensile Test Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForTensileTest(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        setShowUploadPanel(false);
        setUploadCsvData(null);

        let filterId = dppIdSelectedForGlobalFilter?.value || null;
        getTensileTest(filterId, jwtToken);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  useEffect(() => {
    let tempMappedActivity = [];
    let data = getTensileTestReducer?.tensileTest?.data
      ? getTensileTestReducer.tensileTest.data
      : [];

    setLoading(getTensileTestReducer?.loading || false);

    data.map((item) => {
      const itemObject = {
        tensileTestId: item.tensileTestId,
        dppId: item.dppId,
        dppCode: item.dppCode,
        notchimpactStrengthMean: item.notchimpactStrengthMean,
        yeildProofStrengthMean: item.yeildProofStrengthMean,
        tensileStrengthMean: item.tensileStrengthMean,
        testTemperature: item.testTemperature,
        sampleShapeLocationOfSample: item.sampleShapeLocationOfSample,
        directionOfSample: item.directionOfSample,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getTensileTestReducer]);

  // ================= CREATE LOGIC =================
  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
  };

  const handleCloseAllocateItemModal = () => {
    setAllocateItemModal(false);
    formik.setErrors({});
    formik.resetForm();
    setdppIdSelected("");
  };

  useEffect(() => {
    if (isSuccessAllocateItem)
      setTimeout(() => setIsSuccessAllocateItem(false), 3000);
    if (isErrorAllocateItem)
      setTimeout(() => setIsErrorAllocateItem(false), 3000);
  }, [isSuccessAllocateItem, isErrorAllocateItem]);

  const initialValues = {
    DPPID: "",
    notchimpactStrengthMean: "",
    yeildProofStrengthMean: "",
    tensileStrengthMean: "",
    testTemperature: "",
    sampleShapeLocationOfSample: "",
    directionOfSample: "",
  };

  const validationSchema = Yup.object({
    DPPID: Yup.object().required("Select DPP Code"),
    notchimpactStrengthMean: Yup.number()
      .typeError("Must be a number")
      .required("Enter Notch Impact Strength"),
    yeildProofStrengthMean: Yup.number()
      .typeError("Must be a number")
      .required("Enter Yield Proof Strength"),
    tensileStrengthMean: Yup.number()
      .typeError("Must be a number")
      .required("Enter Tensile Strength"),
    testTemperature: Yup.number()
      .typeError("Must be a number")
      .required("Enter Test Temperature"),
    sampleShapeLocationOfSample: Yup.string().required("Enter Sample Location"),
    directionOfSample: Yup.string().required("Enter Sample Direction"),
  });

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      dppId: values.DPPID?.value,
      notchimpactStrengthMean: String(values.notchimpactStrengthMean),
      yeildProofStrengthMean: String(values.yeildProofStrengthMean),
      tensileStrengthMean: String(values.tensileStrengthMean),
      testTemperature: String(values.testTemperature),
      sampleShapeLocationOfSample: values.sampleShapeLocationOfSample,
      directionOfSample: values.directionOfSample,
      cdBy: userId || "system",
    };

    let res = await createTensileTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getTensileTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2000);
    } else {
      setErrorMsg(res?.data?.msg || "Something went wrong");
      setIsErrorAllocateItem(true);
      setAllocateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setdppIdForUpdateSelected({ label: data.dppCode, value: data.dppId });
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const initialValueForUpdate = {
    tensileTestId: singleDataForUpdate.tensileTestId || "",
    DPPID: singleDataForUpdate.dppCode || "",
    notchimpactStrengthMean: singleDataForUpdate.notchimpactStrengthMean || "",
    yeildProofStrengthMean: singleDataForUpdate.yeildProofStrengthMean || "",
    tensileStrengthMean: singleDataForUpdate.tensileStrengthMean || "",
    testTemperature: singleDataForUpdate.testTemperature || "",
    sampleShapeLocationOfSample:
      singleDataForUpdate.sampleShapeLocationOfSample || "",
    directionOfSample: singleDataForUpdate.directionOfSample || "",
  };

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      tensileTestId: values.tensileTestId,
      dppId: singleDataForUpdate.dppId,
      notchimpactStrengthMean: String(values.notchimpactStrengthMean),
      yeildProofStrengthMean: String(values.yeildProofStrengthMean),
      tensileStrengthMean: String(values.tensileStrengthMean),
      testTemperature: String(values.testTemperature),
      sampleShapeLocationOfSample: values.sampleShapeLocationOfSample,
      directionOfSample: values.directionOfSample,
      udBy: userId || "system",
    };

    let res = await editTensileTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getTensileTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  // ================= DELETE LOGIC =================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let testId = singleDataForDelete.tensileTestId;
    let udBy = userId || "system";

    let res = await deleteTensileTest(testId, udBy, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getTensileTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4} display="flex" alignItems="center">
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">

                    {/* 1. Add Record Button */}
                    <Tooltip>
                      <CreateButton tooltip="Add tensile test" onClick={() => setOpenCreateModal(true)}>
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>

                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download tensile test List"
                        style={{ marginLeft: "1rem", }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>



                    {/* 4. Upload Toggle Button */}
                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant={showUploadPanel ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={handleUploadClick}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginLeft: "1rem", }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>description</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {showUploadPanel && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >
                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) => setUploadCsvData(e.target.files[0])}
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={!uploadCsvData?.name || uploadCsvData?.type !== "text/csv"}
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => setShowUploadPanel(false)}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}

                  </MDBox>
                )}
              </MDBox>

              <MDBox mb={4} mr={1}>
                {dropdownUI}
              </MDBox>
            </MDBox>

            {/* DataTable */}
            <MDBox pt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25],
                }}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>

            {/* CREATE MODAL */}
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Tensile Test Record
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                      onClick={handleCloseAllocateItemModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      {/* DPP ID Select */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            DPP Code
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="DPPID"
                            value={dppIdSelected}
                            options={dppOptions}
                            onBlur={() =>
                              formik.handleBlur({ target: { name: "DPPID" } })
                            }
                            onChange={(selectedOption) => {
                              setdppIdSelected(selectedOption);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      {/* Notch Impact Strength */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Notch Impact Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchimpactStrengthMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.notchimpactStrengthMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.notchimpactStrengthMean &&
                              Boolean(formik.errors.notchimpactStrengthMean)
                            }
                          />
                          {formik.touched.notchimpactStrengthMean &&
                            formik.errors.notchimpactStrengthMean && (
                              <TextError
                                msg={formik.errors.notchimpactStrengthMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Yield Proof Strength */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Yield Proof Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="yeildProofStrengthMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.yeildProofStrengthMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.yeildProofStrengthMean &&
                              Boolean(formik.errors.yeildProofStrengthMean)
                            }
                          />
                          {formik.touched.yeildProofStrengthMean &&
                            formik.errors.yeildProofStrengthMean && (
                              <TextError
                                msg={formik.errors.yeildProofStrengthMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Tensile Strength */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Tensile Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="tensileStrengthMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.tensileStrengthMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.tensileStrengthMean &&
                              Boolean(formik.errors.tensileStrengthMean)
                            }
                          />
                          {formik.touched.tensileStrengthMean &&
                            formik.errors.tensileStrengthMean && (
                              <TextError
                                msg={formik.errors.tensileStrengthMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Test Temperature */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Test Temperature
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="testTemperature"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.testTemperature}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.testTemperature &&
                              Boolean(formik.errors.testTemperature)
                            }
                          />
                          {formik.touched.testTemperature &&
                            formik.errors.testTemperature && (
                              <TextError msg={formik.errors.testTemperature} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Location of Sample */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Location of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="sampleShapeLocationOfSample"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter location"
                            value={formik.values.sampleShapeLocationOfSample}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.sampleShapeLocationOfSample &&
                              Boolean(formik.errors.sampleShapeLocationOfSample)
                            }
                          />
                          {formik.touched.sampleShapeLocationOfSample &&
                            formik.errors.sampleShapeLocationOfSample && (
                              <TextError
                                msg={formik.errors.sampleShapeLocationOfSample}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Direction of Sample */}
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Direction of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="directionOfSample"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter direction"
                            value={formik.values.directionOfSample}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.directionOfSample &&
                              Boolean(formik.errors.directionOfSample)
                            }
                          />
                          {formik.touched.directionOfSample &&
                            formik.errors.directionOfSample && (
                              <TextError
                                msg={formik.errors.directionOfSample}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Alerts & Submit */}
                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={allocateButtonName === "Please wait..."}
                          >
                            {allocateButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* UPDATE MODAL */}
            <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update Tensile Test
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        // marginLeft: "-55px",
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseUpdateModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">DPP Code</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="DPPID"
                            fullWidth
                            disabled={true}
                            value={formikForUpdate.values.DPPID}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Notch Impact Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchimpactStrengthMean"
                            fullWidth
                            value={
                              formikForUpdate.values.notchimpactStrengthMean
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Yield Proof Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="yeildProofStrengthMean"
                            fullWidth
                            value={
                              formikForUpdate.values.yeildProofStrengthMean
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Tensile Strength (Mean)
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="tensileStrengthMean"
                            fullWidth
                            value={formikForUpdate.values.tensileStrengthMean}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Test Temperature
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="testTemperature"
                            fullWidth
                            value={formikForUpdate.values.testTemperature}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Location of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="sampleShapeLocationOfSample"
                            fullWidth
                            value={
                              formikForUpdate.values.sampleShapeLocationOfSample
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Direction of Sample
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="directionOfSample"
                            fullWidth
                            value={formikForUpdate.values.directionOfSample}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>

            {/* DELETE MODAL */}
            <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="error"
                    onClick={deleteRecord}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorForDelete}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsErrorForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForDelete}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForDelete}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsSuccessForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Deleted Successfully
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <CreateTestRecordModal
              open={openCreateModal}
              handleClose={() => setOpenCreateModal(false)}
              jwtToken={jwtToken}
              userId={userId}
              dppOptions={dppOptions}
              onSuccessRefresh={(testTypeCreated) => { }}
            />
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  getTensileTestReducer: state.getTensileTestReducer,
  getProductsListForDppReducer: state.getProductsListForDppReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getTensileTest: (dppId, jwtToken) =>
    dispatch(getTensileTest(dppId, jwtToken)),
  createTensileTest: (payload, jwtToken) =>
    dispatch(createTensileTest(payload, jwtToken)),
  editTensileTest: (payload, jwtToken) =>
    dispatch(editTensileTest(payload, jwtToken)),
  deleteTensileTest: (testId, udBy, jwtToken) =>
    dispatch(deleteTensileTest(testId, udBy, jwtToken)),
  getProductsListForDpp: (jwtToken) =>
    dispatch(getProductsListForDpp(jwtToken)),
  uploadCsvForTensileTest: (data, jwtToken) =>
    dispatch(uploadCsvForTensileTest(data, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TensileTest);
